export default {
    // 左侧导航
    Navigation:{
        logon:"点击登录",
        homePage:"首页",
        explore:"探索",
        vip:"开通会员",
        setUp:"设置",
        Popular:"热门歌单",
        liuxing:"流行歌单",
        jingdian:"经典歌单",
        shoucang:"最近播放"
    },
    //顶部导航
    TOPnav:{
        sousuo:"搜索"
    },
    //登录页面
    logIn:{
        logtilte:"登录",
        input_plac:"用户名/邮箱",
        input_password:"密码",
        denglu:"登录",
        input_tishi_user:"用户名/邮箱 不能为空",
        input_tishi_mima:"密码不能为空",
        wangji_password:"忘记密码?",
        no_username:"还没有账号？注册",
        duowenzi:"密码已通过md5+salt加密传输，使用hash保存"
    },
    //个人页
    geren:{
        dongtai:"动态",
        guanzhu:"关注",
        fensi:"粉丝",
        el_label1:"基本信息",
        el_label2:"安全设置",
        new_username:"新用户名",
        new_username_tishi:"请输入新用户名",
        useName:"用户名",
        save:"保存",
        LoginPassword:"登录密码",
        shezhi_text:"已设置。密码至少6位字符，支持数字、字母，且必须同时包含数字和大小写字母。",
        modify:"修改",
        form_title_mima:"密码修改",
        from_jiumima:"旧密码",
        from_tishi:"原密码错误",
        from_xinmima:"新密码",
        from_confirm_mima:"确认新密码",
        from_tishi2:"两个密码不一致",
        modifyMima:"修改密码",
        shiming:"实名认证",
        upImg:" 上传身份证 正反面，完成实名认证信息。 ",
        shangchuan:"上传",
        tuichu:"退出登录"
    },
    //注册页
    zhuce:{
        // 注意事项并同意
        reg_tilte:"新用户注册",
        beCareful:"如果要在此服务器上注册，需要确认并同意一下内容。",
        read:"请好好阅读，这真的很重要。",
        fuwuGuize:"服务器规则",
        guizetext1:"严禁上传包含色情、暴力或宣扬恐怖主义的图片及头像",
        guizetext2:"禁止发送 违反中国法律 的内容",
        guizetext3:"尊重他人，勿引战，勿发表攻击性言论",
        guizetext4:"谢绝 无意义刷屏，广告推送 类用户注册使用",
        guizetext5:"不参与三次元键政，包括转发",
        yes:"同意",
        fuwu_tiaokuai:"用户协议及隐私政策",
        tiaokuai:"用户协议",
        yinsi:"隐私政策",
        gouXuan:"必须全部勾选 ⌊同意⌉ 才能下一步",
        nextStep:"下一步",
        Gologin:"已有账号, 去登录",
        // 注册
        zhucetilte:"注册",
        useName:"用户名",
        nameEnmle_input:"用户名/邮箱",
        z_input_tishi:"用户名/邮箱不能为空",
        mima:"密码",
        input_mima:"密码",
        p_tilte_mima:"密码不能为空",
        confirm_mima:"确认密码",
        p_tishi:"密码不一致",
        shouji:"手机号",
        p_tishi2:"请输入正确的手机号",
        yzm_tilte:"验证码",
        yzm_input_tishi:"请输入验证码",
        yzm_obtain:"获取验证码",
        yzm_cuowu:"验证码错误",
        zhuce_Button:"注册",
        PreviousStep:"上一步"
    },
    //home
    Homedata:{
        tilte1:"歌单",
        tilte2:"推荐歌手",
        tilte3:"单曲推荐",
        tilte4:"热门歌曲",
        shezhi1:"关于ios后台播放",
        shezhi2:"由于ios限制无法在后台切换歌曲，可以添加到主屏幕、升级到ios16.1.1"
    },
    //设置
    SetUp:{
        text_tilte1:"主题",
        text_p_Subtitle:"自定义您的应用程序主题",
        R_tilte_ys:"主题颜色模式",
        R_Subtitle_ys:"系统",
        R_songci_ys:"歌词颜色模式",
        R_songci_sub_ys:"亮色",
        language:"语言选择",
        two_tilte:"常规",
        donghua:"动画",
        NOdonghua:"禁用动画效果 √",
        three_tilte:"播放",
        bofanglist:"播放列表",
        bofang_text:"双击播放单曲时，仅把当前单曲添加到播放列表",
        four_tilte:"快捷键",
        key_bofang:"播放/暂停",
        key_shang:"上一首",
        key_xia:"下一首",
        key_yinliang_top:"增加音量",
        key_yinliang_bou:"减少音量",
        key_sousuo:"打开搜索",
        key_songci:"关闭歌词",
    },
    // 找回密码
    Retrieve:{
        zh_mima:"找回密码",
        shoujihao:"注册的手机号",
        p_tishi:"手机号不正确",
        zhaohui:"找回密码"
    },
    // 单曲 列表的表头
    songList:{
        songTilte:"歌曲",
        geshou:"歌手",
        zhuanji:"专辑",
        shichang:"时长"
    },
    // 收藏
    Collect_songs:"最近播放",
    //搜索
    search:{
        name1:"搜索结果",
        name2:"单曲"
    },
    //歌手歌单的详情页 播放全部
    PlayAll:"播放全部",
    //会员页面
    member:{
        huiText2:"开通会员，可解锁全站音乐无损音质下载权限，随时随地将高品质音乐收入囊中 开启极致音乐体验之旅 。",
        huiText:"你值得拥有, 会员充值, 一键开启高品质生活",
        huitilte:"音乐VIP",
        xufei1:"到期自动续费",
        xufei2:"元 可手动取消",
        way:"请使用微信扫码支付",
        xufei:"是否同意自动续费协议",
        xieyi1:"《酷皮音乐服务条款》",
        xieyi2:"《音乐VIP服务条款》",
        xieyi3:"《自动续费服务协议》"
    }

}